// Roomvo script loader and anchor handler
//
// The vendor script is needed in two different ways, and that decides when it
// loads:
//
//  - Product pages: snippets/roomvo-button.liquid renders its buttons
//    visibility:hidden and Roomvo's own script unhides them (their required
//    integration pattern). Wherever a .roomvo-container exists in the DOM the
//    script must load on page load, or the buttons never appear.
//
//  - Every other page: the only entry points are #roomvo anchors and
//    [data-roomvo-open] elements. There the script loads on first interaction
//    with a trigger (warmed on pointerover, fetched on click), not on page
//    load — it was previously ~200KB of vendor JS on every page of the site
//    for a feature almost nobody invokes outside the PDP.

(function () {
  if (window.__bdRoomvoAnchorsV2) return;
  window.__bdRoomvoAnchorsV2 = true;

  var SRC = "https://cdn.roomvo.com/static/scripts/b2b/builddirect.js";
  var requested = false;
  var loadFailed = false;

  function loadRoomvoScript() {
    if (requested) return;
    requested = true;
    if (document.querySelector('script[src="' + SRC + '"]')) return;
    var s = document.createElement('script');
    s.src = SRC;
    s.defer = true;

    // A failed load is otherwise invisible. The PDP buttons render
    // visibility:hidden for Roomvo's script to unhide (see
    // snippets/roomvo-button.liquid), so a 404, a blocked request or a CSP
    // rejection just looks like the feature was never installed. This is the
    // same silent-failure trap that hid the pixel 404 for months — see
    // docs/tracking-cleanup-runbook-2026-08.md section 7.
    s.onerror = function () {
      loadFailed = true;
      // Allow a later trigger interaction to retry: a failed fetch can be
      // transient, and the dead tag would otherwise satisfy the querySelector
      // guard above and block every subsequent attempt.
      requested = false;
      if (s.parentNode) s.parentNode.removeChild(s);
      console.error(
        "[Roomvo] visualizer script failed to load (" + SRC +
        "); the visualizer buttons will not appear."
      );
    };
    s.onload = function () {
      loadFailed = false;
    };

    document.head.appendChild(s);
  }

  function hasRoomvoUi() {
    // Containers whose buttons only Roomvo's script can unhide.
    return !!document.querySelector('.roomvo-container, .roomvo-container_3d');
  }

  function getHashFromHref(href) {
    try {
      var u = new URL(href, window.location.href);
      return (u.hash || "").toLowerCase();
    } catch (e) {
      // fallback for odd href values
      href = href || "";
      var i = href.indexOf("#");
      return i >= 0 ? href.slice(i).toLowerCase() : "";
    }
  }

  function getRoomvoOpener() {
    // Return a function that opens Roomvo, or null if not ready
    if (window.roomvo && typeof window.roomvo.startStandaloneVisualizer === "function") {
      return function(){ window.roomvo.startStandaloneVisualizer(); };
    }
    if (window.RVWPortal && typeof window.RVWPortal.open === "function") {
      return function(){ window.RVWPortal.open(); };
    }
    if (window.Roomvo && typeof window.Roomvo.open === "function") {
      return function(){ window.Roomvo.open(); };
    }
    if (window.roomvo && typeof window.roomvo.open === "function") {
      return function(){ window.roomvo.open(); };
    }
    return null;
  }

  function openRoomvoWithRetry() {
    loadRoomvoScript();

    var opener = getRoomvoOpener();
    if (opener) {
      opener();
      return true;
    }

    // The script may still be downloading — on the lazy path it only started
    // at this click. Retry within the user-gesture window; 10s covers a
    // cold fetch on a slow mobile connection.
    var tries = 0;
    var maxTries = 100;
    var timer = setInterval(function () {
      tries++;
      var fn = getRoomvoOpener();
      if (fn) {
        clearInterval(timer);
        fn();
      } else if (loadFailed) {
        // Nothing to wait for — stop polling instead of burning the full
        // retry window on a request that already errored.
        clearInterval(timer);
        console.error("[Roomvo] cannot open the visualizer: " + SRC + " failed to load.");
      } else if (tries >= maxTries) {
        clearInterval(timer);
        console.warn("[Roomvo] API not ready after retry window.");
      }
    }, 100);

    return true;
  }

  function shouldHandle(el) {
    if (!el) return false;

    // data-roomvo-open always qualifies
    if (el.hasAttribute && el.hasAttribute("data-roomvo-open")) return true;

    // Anchor hashes: accept "#roomvo" even if href is a full URL containing it
    if (el.tagName && el.tagName.toLowerCase() === "a") {
      var href = el.getAttribute("href") || "";
      return getHashFromHref(href) === "#roomvo";
    }

    return false;
  }

  function closestTrigger(target) {
    var el = target && target.closest
      ? target.closest('a, [data-roomvo-open]')
      : null;
    return shouldHandle(el) ? el : null;
  }

  function handler(e) {
    if (!closestTrigger(e.target)) return;

    // Stop menu / drawer scripts from hijacking the click first
    e.preventDefault();
    e.stopPropagation();

    openRoomvoWithRetry();
  }

  // Start the download as soon as a pointer settles on a trigger, so the
  // script is usually in flight (or cached) before the click lands.
  function warm(e) {
    if (closestTrigger(e.target)) loadRoomvoScript();
  }

  // Capture phase is key for mobile menus
  document.addEventListener("click", handler, true);

  // Some mobile menus behave better with touchend
  document.addEventListener("touchend", handler, { capture: true, passive: false });

  document.addEventListener("pointerover", warm, true);
  document.addEventListener("touchstart", warm, { capture: true, passive: true });
  document.addEventListener("focusin", warm, true);

  // If someone lands on a URL ending in #roomvo, open automatically
  function autoOpenIfHash() {
    if ((window.location.hash || "").toLowerCase() !== "#roomvo") return;
    // Give the Roomvo script a moment
    setTimeout(openRoomvoWithRetry, 0);
  }
  window.addEventListener("hashchange", autoOpenIfHash);
  autoOpenIfHash();

  // Eager path: load now where Roomvo's own UI is on the page, and re-check at
  // window load for content rendered after this script ran (Shogun pages).
  if (hasRoomvoUi()) {
    loadRoomvoScript();
  } else if (document.readyState !== "complete") {
    window.addEventListener("load", function () {
      if (hasRoomvoUi()) loadRoomvoScript();
    });
  }
})();
